var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyInpl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 139,
    viewBox: "0 0 109 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.4996,
    cy: 54.0641,
    r: 53.732,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.4211,
    y: 52.9711,
    width: 52.6048,
    height: 73.6467,
    rx: 5.26048,
    transform: "rotate(2.5 33.4211 52.9711)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 1.50299
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.14708,
    y: 48.564,
    width: 55.6108,
    height: 76.6527,
    rx: 6.76347,
    transform: "rotate(-7.5 2.14708 48.564)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 1.50299
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77496 55.1715C3.34157 51.8796 5.65886 48.8596 8.95078 48.4262L50.6746 42.9332C53.9665 42.4998 56.9864 44.8171 57.4198 48.109L58.8912 59.285L5.24631 66.3475L3.77496 55.1715Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.3027,
    y: 44.4023,
    width: 2.25449,
    height: 7.51497,
    rx: 1.12725,
    transform: "rotate(82.5 68.3027 44.4023)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7129,
    y: 31.9531,
    width: 2.25449,
    height: 7.51497,
    rx: 1.12725,
    transform: "rotate(-7.5 47.7129 31.9531)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.9238,
    y: 34.0039,
    width: 2.25449,
    height: 7.51497,
    rx: 1.12725,
    transform: "rotate(37.5 60.9238 34.0039)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8555,
    y: 68.6406,
    width: 43.5868,
    height: 3.00599,
    rx: 1.50299,
    transform: "rotate(-7.5 10.8555 68.6406)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8164,
    y: 83.543,
    width: 43.5868,
    height: 3.00599,
    rx: 1.50299,
    transform: "rotate(-7.5 12.8164 83.543)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7793,
    y: 98.4453,
    width: 43.5868,
    height: 3.00599,
    rx: 1.50299,
    transform: "rotate(-7.5 14.7793 98.4453)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6387,
    y: 74.6016,
    width: 15.7814,
    height: 3.00599,
    rx: 1.50299,
    transform: "rotate(-7.5 11.6387 74.6016)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6016,
    y: 89.5039,
    width: 15.7814,
    height: 3.00599,
    rx: 1.50299,
    transform: "rotate(-7.5 13.6016 89.5039)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5625,
    y: 104.406,
    width: 15.7814,
    height: 3.00599,
    rx: 1.50299,
    transform: "rotate(-7.5 15.5625 104.406)",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInpl);
export default __webpack_public_path__ + "static/media/empty-inpl.bb787d31.svg";
export { ForwardRef as ReactComponent };